<template>
  <v-toolbar class="ml-4 wd-100" color="transparent">
    <v-toolbar-title style="font-size: 24px; font-weight: bold"
      >{{ this.projeto }} - Casos de Uso</v-toolbar-title
    >
    <UseCaseModal
      v-if="isDev"
      @caso-de-uso-criado="onCasoDeUsoCriado"
      :fetch-use-cases="this.fetchUseCasesByProject"
    />
  </v-toolbar>

  <div class="ml-8">
    <v-checkbox
      v-model="isDraft"
      label="Mostrar apenas os rascunhos"
      color="primary"
      hide-details
    ></v-checkbox>
  </div>

  <v-table
    class="ma-8 mt-1 usecase--table elevation-1"
    style="background: transparent"
    fixed-header="true"
    density="comfortable"
    ><thead class="text-grey">
      <tr>
        <th class="rounded-ts-lg pl-10 text-left text-grey">Identificador</th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Caso de Uso
        </th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Prioridade
        </th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Story Points
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="rounded-te-lg text-left text-grey"
        >
          Status
        </th>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Ações
        </th>
      </tr>
    </thead>
    <div class="split"></div>
    <tbody>
      <tr v-for="item in filteredUseCases" :key="item.id_caso_de_uso">
        <td class="pl-10 text-left">{{ item.identificador }}</td>

        <td style="border-left: thin solid #efefef" class="text-left">
          <RouterLink
            :to="
              '/projects/' + this.idProjeto + '/CasoUso/' + item.id_caso_de_uso
            "
          >
            <p class="text-decoration-underline">{{ item.nome }}</p>
          </RouterLink>
        </td>

        <td style="border-left: thin solid #efefef" class="text-center">
          <PriorityTag :priority="item.prioridade" />
        </td>

        <td style="border-left: thin solid #efefef" class="text-left">
          {{ item.storypoint }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-center">
          {{ converterEnumParaTexto(item.status) }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-left">
          <v-row class="align-center">
            <v-col cols="2">
              <RouterLink
                :to="
                  '/projects/' +
                  this.idProjeto +
                  '/CasoUso/' +
                  item.id_caso_de_uso
                "
              >
                <v-icon
                  size="large"
                  color="green-darken-2"
                  icon="mdi-eye-arrow-right-outline"
                ></v-icon>
              </RouterLink>
            </v-col>

            <v-col cols="2">
              <EditCSU
                v-if="isDev"
                :caso-de-uso-p="item"
                :id="item.id_caso_de_uso"
                class="ml-2 ml-lg-n2"
                @caso-de-uso-editado="fetchUseCasesByProject"
                @rascunho-salvo="fetchUseCasesByProject"
              />
            </v-col>
          </v-row>
        </td>
      </tr>
    </tbody>
  </v-table>

  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>
<script>
import axios from 'axios';

import EditCSU from '@/components/dialogs/EditCSU.vue';
import UseCaseModal from '@/components/dialogs/UseCaseModal.vue';
import PriorityTag from '@/components/PriorityTag.vue';
import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';
export default {
  name: 'TabelaUseCases',
  components: {
    PriorityTag,
    UseCaseModal,
    EditCSU,
  },

  /**
   * @module UseCasesTable
   * @desc Tabela que mostra a lista de CSU por ID projeto.
   * @vue-data {number} [idProjeto=null] - O ID do projeto.
   * @vue-data {boolean} [isLoading=false] - Indica se a
   * tabela está sendo carregada ou não.
   * @vue-data {Array} [useCases=[]] - A lista de CSUs.
   * @vue-data {String} [projeto=''] - Nome do projeto.
   * @vue-data {String} [isDraft=false] - Flag que indica se apenas
   * os rascunhos devem ser listados.
   * @vue-computed {Boolean} isDev - Flag que indica se o usuário
   * atual é desenvolvedor no projeto.
   * @vue-computed {Array.<Object>} filteredUseCases - Lista com
   * todos os casos de uso ou com apenas aqueles que estão em edição.
   */
  data() {
    return {
      useCases: [],
      projeto: '',
      idProjeto: null,
      isLoading: false,
      isDraft: false,
    };
  },
  created() {
    this.idProjeto = this.$route.params.idProjeto;
    this.projeto = localStorage.getItem('projeto');

    this.fetchUseCasesByProject();
  },
  computed: {
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },

    filteredUseCases() {
      if (this.isDraft) {
        return this.useCases.filter(
          (useCase) => useCase.status === 'EM_EDICAO',
        );
      }

      return this.useCases;
    },
  },
  methods: {
    /**
     * Formata as strings do enum;
     */
    converterTextoParaEnum(string) {
      /// GRAVIDADE.
      if (string === 'Bloqueadora') {
        return 'BLOQUEADORA';
      } else if (string === 'Crítica') {
        return 'CRITICA';
      } else if (string === 'Média') {
        return 'MEDIA';
      } else if (string === 'Baixa') {
        return 'BAIXA';
      } else if (string === 'Trivial') {
        return 'TRIVIAL';
      }
      /// TIPO.
      if (string === 'Correção') {
        return 'CORRECAO';
      } else if (string === 'Melhoria') {
        return 'MELHORIA';
      }
      /// STATUS
      if (string === 'Em edição') {
        return 'EM_EDICAO';
      } else if (string === 'Definido') {
        return 'DEFINIDO';
      } else if (string === 'Em implementação') {
        return 'EM_IMPLEMENTACAO';
      } else if (string === 'Implementado') {
        return 'IMPLEMENTADO';
      } else if (string === 'Testado') {
        return 'TESTADO';
      } else if (string === 'Cancelado') {
        return 'CANCELADO';
      } else {
        return string;
      }
    },
    converterEnumParaTexto(string) {
      /// GRAVIDADE.
      if (string === 'BLOQUEADORA') {
        return 'Bloqueadora';
      } else if (string === 'CRITICA') {
        return 'Crítica';
      } else if (string === 'MEDIA') {
        return 'Média';
      } else if (string === 'BAIXA') {
        return 'Baixa';
      } else if (string === 'TRIVIAL') {
        return 'Trivial';
      }
      /// TIPO.
      if (string === 'CORRECAO') {
        return 'Correção';
      } else if (string === 'MELHORIA') {
        return 'Melhoria';
      }
      /// STATUS
      if (string === 'EM_EDICAO') {
        return 'Em edição';
      } else if (string === 'DEFINIDO') {
        return 'Definido';
      } else if (string === 'EM_IMPLEMENTAÇÃO') {
        return 'Em implementação';
      } else if (string === 'IMPLEMENTADO') {
        return 'Implementado';
      } else if (string === 'TESTADO') {
        return 'Testado';
      } else if (string === 'CANCELADO') {
        return 'Cancelado';
      } else {
        return string;
      }
    },
    // pega valor do status CSU
    async verificaERetornaStatusCSU(item) {
      try {
        if (item.status === 'EM_IMPLEMENTACAO') {
          const resultadoImplementacoes = await this.analisaImplementacoes(
            item.id_caso_de_uso,
          );
          if (resultadoImplementacoes) {
            this.useCases.find(
              (x) => x.id_caso_de_uso === item.id_caso_de_uso,
            ).status = 'IMPLEMENTADO';
            await axios.patch(
              `${apiUrl}/api/v1/productBacklog/status/${item.id_caso_de_uso}`,
              { status: 'IMPLEMENTADO' },
              {
                headers: {
                  Authorization: `Bearer ${store.state.token}`,
                },
              },
            );
          }
        } else if (item.status === 'IMPLEMENTADO') {
          const resultadoImplementacoes = await this.analisaCharters(
            item.id_caso_de_uso,
          );
          if (resultadoImplementacoes) {
            this.useCases.find(
              (x) => x.id_caso_de_uso === item.id_caso_de_uso,
            ).status = 'TESTADO';
            await axios.patch(
              `${apiUrl}/api/v1/productBacklog/status/${item.id_caso_de_uso}`,
              { status: 'TESTADO' },
              {
                headers: {
                  Authorization: `Bearer ${store.state.token}`,
                },
              },
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Pega os CSU a partir de um ID projeto.
     */
    fetchUseCasesByProject() {
      this.isLoading = true;
      axios
        .get(apiUrl + '/api/v1/productBacklog/projeto/' + this.idProjeto, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          this.useCases = res.data.useCases;
          console.log('useCases', this.useCases);
          this.isLoading = false;
          this.useCases.forEach((item) => {
            this.verificaERetornaStatusCSU(item);
          });
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },
    async analisaImplementacoes(idCSU) {
      try {
        const res = await axios.get(apiUrl + '/api/v1/implementacao/' + idCSU, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        });

        return res.data.implementacoes.every(
          (x) => x.tb_implementacao.tb_tarefa.status_tarefa === 'FINALIZADO',
        );
      } catch (error) {
        console.log(error);
      }
    },
    async analisaCharters(idCSU) {
      try {
        const res = await axios.get(apiUrl + '/api/v1/charters/csu/' + idCSU, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        });
        console.log(res.data.charters);

        return res.data.charters.every((x) => x.status_charter === 'EXECUTADO');
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.usecase--table .split {
  background-color: #f9f8f8;
  height: 1rem;
}

.usecase--table tbody tr {
  background-color: #fff;
}

.usecase--table a {
  text-decoration: none;
  color: black;
}
</style>
